﻿import { pagination } from "../../pagination";
import { response_booking } from "./response_booking";
import { response_booking_passenger } from "./response_booking_passenger";

export class booking_search_response {
    public pagination: pagination = new pagination();
    public bookings: response_booking[] = [];
    public passengers: response_booking_passenger[] = [];
}